import { Button } from "@/components/common/Button";
import Progress from "@/components/common/Progress";
import { useNetworkStore } from "@/modules/auth/store/network";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const Nesting = () => {
  const { t } = useTranslation();

  const { path, tree, backPath } = useNetworkStore();

  const filled =
    path
      .split(",")
      .map((i) => i.trim())
      .filter((i) => i !== "").length + 1;

  const total = 10;

  const parent = useMemo(() => {
    if (!path) return null;

    const pathArr = path
      .split(",")
      .map((i) => i.trim().toUpperCase())
      .filter((i) => i !== "");

    let currentLevel = tree;

    for (let i = 0; i < pathArr.length; i++) {
      const refCode = pathArr[i];

      const node = currentLevel.find(
        (r) => r.refCode.toUpperCase() === refCode
      );

      if (!node) return null;

      if (i === pathArr.length - 1) {
        return node;
      }

      currentLevel = node.children || [];
    }

    return null;
  }, [path, tree]);

  const refCode = parent?.refCode;

  return (
    <div className="flex flex-col gap-5 p-4 border-b border-divider box-content">
      {filled > 1 && (
        <Button
          onClick={backPath}
          text={t("network-page.prev_page")}
          mode="bezeled"
          className="w-full text-[0.9375rem] !leading-[1.25rem]"
        />
      )}

      <div className="flex flex-col px-4 pt-4 gap-1">
        <div className="flex pb-4">
          <Progress filled={filled} total={total} />
        </div>
        {filled > 1 ? (
          <div className="w-full flex items-center gap-4">
            <div className="flex-1 flex flex-col items-start gap-0.5 py-3">
              <p
                className={`text-[1.0625rem] leading-[1.375rem] ${
                  parent?.telegramUsername ? "text-text" : "text-subtitle-text"
                }`}
              >
                {parent?.telegramUsername
                  ? `@${parent.telegramUsername}`
                  : parent?.name
                  ? parent.name
                  : t("network-page.no_username")}
              </p>
              <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text text-left">
                {t("network-page.own_deposit")}: ${parent?.ownDeposit}
              </p>
              <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text text-left">
                {refCode}
              </p>
            </div>

            <p className="text-[0.8125rem] leading-[1rem] text-section-header-text">
              {t("network-page.level_of", { filled, total })}
            </p>
          </div>
        ) : (
          <p className="text-[0.8125rem] leading-[1rem] text-section-header-text text-center">
            {t("network-page.level_of", { filled: 1, total })}
          </p>
        )}
      </div>
    </div>
  );
};

export default Nesting;
